module.exports = __webpack_public_path__ + "static/media/icon-event__guerra-civil-espanola.1edcd3a4.svg";